<template>
    <div style="padding-top: 70px;overflow-x: hidden">
        <el-row>
            <el-col :span="20" :offset="2">
                <img src="../assets/lianxi.jpg" style="width: 100%" alt="lianxi" title="lianxi"/>

                <div class="aaaa">
                    <el-row :gutter="35">

                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <div class="grid-content bg-purple" style="padding: 18px 35px">
                                <div class="zong">Hauptquartier Nanjing</div>
                                <div>
                                    <ul>
                                        <li class="zong1">Kontakte：Herr Hu.</li>
                                        <li class="zong1">Adresse：Xinhe Industrial Park, Qixia District, Nanjing City</li>
                                        <li class="zong1">Telefon：+86-025-85593856 85614061</li>
                                        <li class="zong1">Faksimile：+86-025-85502771 85592481</li>
                                        <li class="zong1">Handy：+86 189 1398 1759</li>
                                        <li class="zong1">Postfach：ifcores@hotmail.com</li>
                                    </ul>
                                </div>
                            </div>
                        </el-col>
                        <el-col  :xs="24" :sm="24" :md="12" :lg="12">
                            <div class="grid-content bg-purple" style="padding: 18px 35px">
                                <div class="zong">TianChang</div>
                                <div>
                                    <ul>
                                        <li class="zong1">Kontakte：Herr Hu.</li>
                                        <li class="zong1">Adresse：Zhangpu Stadt, Tianchang Stadt, Provinz Anhui</li>
                                        <li class="zong1">Telefon：+86-025-85593856 85614061</li>
                                        <li class="zong1">Handy：+86 189 1470 8320</li>
                                        <li class="zong1">Postfach：ifcores@hotmail.com</li>
                                        <li class="zong1">&nbsp;</li>
                                    </ul>
                                </div>
                            </div>
                        </el-col>


                    </el-row>
                    <el-row :gutter="35">
                        <el-col :xs="24" :sm="24" :md="8" :lg="8">
                            <div class="grid-content bg-purple" style="padding: 18px">
                                <div class="zong">Russische Firma</div>
                                <div>
                                    <ul>
                                        <li class="zong1">Telefon1:+7 (812) 369-51-80;740-53-05;</li>
                                        <li class="zong1">Telefon2:+7 (812) 369-11-54;740-53-06;</li>
                                        <li class="zong1">Telefon3:+7 (812) 369-89-20;369-38-97;</li>
                                    </ul>
                                </div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="8" :lg="8">
                            <div class="grid-content bg-purple" style="padding: 18px">
                                <div class="zong">Shenzhen</div>
                                <div>
                                    <ul>
                                        <li class="zong1">Kontakte:Liu</li>
                                        <li class="zong1">Handy:+86 13417404261</li>
                                        <li class="zong1">&nbsp;</li>
                                    </ul>
                                </div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="8" :lg="8">
                            <div class="grid-content bg-purple" style="padding: 18px">
                                <div class="zong">Spanien</div>
                                <div>
                                    <ul>
                                        <li class="zong1">Telefon:+34.93.672.4610</li>
                                        <li class="zong1">Faksimile:+34.93.656.5327</li>
                                        <li class="zong1">&nbsp;</li>
                                    </ul>
                                </div>
                            </div>
                        </el-col>

                    </el-row>
                    <el-row :gutter="35">

                        <el-col :xs="24" :sm="24" :md="8" :lg="8">
                            <div class="grid-content bg-purple" style="padding: 18px">
                                <div class="zong">Deutsche Gesellschaft</div>
                                <div>
                                    <ul>
                                        <li class="zong1">Telefon:+49 (0) 7948 9418-0</li>
                                        <li class="zong1">Faksimile:+49 (0) 7948 9418-29</li>
                                        <li class="zong1">Adresse:Ohrnberger Strasse 24 - 74670 Sindringen</li>
                                    </ul>
                                </div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="8" :lg="8">
                            <div class="grid-content bg-purple" style="padding: 18px">
                                <div class="zong">Ukrainische Firma</div>
                                <div>
                                    <ul>
                                        <li class="zong1">Telefon:(+38) 057-757-2859</li>
                                        <li class="zong1">Faksimile: (+38) 057-728-1808</li>
                                        <li class="zong1"><a href="http://www.ferrite.com.ua">http://www.ferrite.com.ua</a></li>
                                    </ul>
                                </div>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row style="margin-top: 50px">
                        <map-container></map-container>
                    </el-row>
                </div>
                <!--                留言-->
                <div class="message" >
                    <!--                    <div style="height: 220px;width: 100vw;position: absolute;bottom: 0;left: calc(-100vw / 24 * 2);background-color:#f4f8fb "></div>-->
                    <h1 style="text-align: center">Online-Nachricht</h1>
                    <p style="font-size: 18px;color: #999;margin-top: 5px;line-height: 36px;text-transform: capitalize;text-align: center">Willkommen auf unserer offiziellen Website. Wir werden alle Probleme von ganzem Herzen für Sie lösen</p>
                    <el-form ref="form" :model="form" >
                        <el-row gutter="50">
                            <el-col :xs="24" :sm="24" :md="12" :lg="12">

                                <el-form-item label="Kontakte">
                                    <el-input v-model="form.name" prefix-icon="el-icon-user" placeholder="Kontakte"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" :lg="12">

                                <el-form-item label="Telefon">
                                    <el-input v-model="form.tel" prefix-icon="el-icon-phone" placeholder="Telefon"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" :lg="12">

                                <el-form-item label="E-Mail">
                                    <el-input v-model="form.mail" prefix-icon="el-icon-message" placeholder="E-Mail"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" :lg="12">

                                <el-form-item label="Adresse">
                                    <el-input v-model="form.address" prefix-icon="el-icon-location-outline" placeholder="dresse"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">

                                <el-form-item label="Nachrichteninhalt">
                                    <el-input type="textarea" v-model="form.desc" placeholder="Bitte füllen Sie Ihre Anforderungen aus" >

                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" :lg="12" >

                                <h3 style="text-align: left ;color: red;padding:20px">Bitte seien Sie versichert, dass ich diese Informationen vertraulich behandeln und niemandem offenlegen werde</h3>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                <el-form-item style="text-align: right">
                                    <el-button type="primary" @click="onSubmit" style="padding:20px 40px ">Jetzt abschicken</el-button>

                                </el-form-item>
                            </el-col>

                        </el-row>
                    </el-form>
                </div>

            </el-col>
            <el-col :span="24">
                <foot/>
            </el-col>
        </el-row>


    </div>
</template>

<script>
    import Foot from "@/DE/components/Foot";
    import MapContainer from "@/DE/components/MapContainer";
    import request from "@/utils/request";
    let websockets = null;
    export default {
        name: "Contact us",
        components:{Foot,MapContainer},
        metaInfo: {
            title: 'Kontaktieren Sie uns| Nanjing Hengchuang Magnetoelectronics Co., Ltd', // set a title
            meta: [{
                // 设置meta信息
                name: 'Kontaktieren Sie uns',
                content: 'Kontaktieren Sie uns'
            }]
        },
        data(){
            return{
                form: {
                    name: '',
                    tel: '',
                    mail: '',
                    address: '',
                    desc: ''
                }


            }
        },
        beforeRouteEnter(to,form,next){



            request.get("/contact/zh").then(res =>{
                next(vm => {
                    vm.list = res.data;

                })
            }).catch((res)=>{
            })
        },
        methods:{
            onSubmit(){

                websockets.send(JSON.stringify(this.form))
                alert("SUCCESS")
            },

            heartCheck() {
                this.a = {
                    timeout: 60000,//60秒
                    timeoutObj: null,
                    serverTimeoutObj: null,
                    reset: function () {
                        clearTimeout(this.timeoutObj);
                        clearTimeout(this.serverTimeoutObj);
                        return this;
                    },
                    start: function () {
                        var self = this;
                        this.timeoutObj = setTimeout(function () {
                            //这里发送一个心跳，后端收到后，返回一个心跳消息，
                            //onmessage拿到返回的心跳就说明连接正常
                            // websockets.send("HeartBeat");

                            self.serverTimeoutObj = setTimeout(function () {//如果超过一定时间还没重置，说明后端主动断开了
                                // ws.onclose();//如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
                            }, self.timeout)
                        }, this.timeout)
                    }
                }
            },

            //关闭WebSocket连接
            closeWebSocket() {
                websockets.close();
            },


            // 建立连接的方法
            openWebSocket() {
                websockets = new WebSocket("ws://203.191.149.84:8081/webIfcores/ifcores");
                websockets.onopen = function () {
                    // websockets.send("连上了哥们789","123")
//	setMessageInnerHTML("WebSocket连接成功");
//                     console.log("WebSocket连接成功");
                }
            }

        },
        mounted() {
            // -----------------------------------------------------------------------------------------------
            if ('WebSocket' in window) {
                //console.log("浏览器支持Websocket");
                // websockets = new WebSocket("ws://localhost:8081/websocket2");

                this.openWebSocket()

            } else {
                // alert('当前浏览器 Not support websocket')
            }
            //判断当前浏览器是否支持WebSocket，是则创建WebSocket


            //连接发生错误的回调方法
            websockets.onerror = function () {
                console.log("WebSocket连接发生错误");
                // setMessageInnerHTML("WebSocket连接发生错误");
            };

            //连接关闭的回调方法
            websockets.onclose = function () {
                console.log("WebSocket连接关闭");
            }


        },
        beforeRouteLeave(){
            this.closeWebSocket();

        }

    }
</script>

<style scoped lang="less">

    ul{
        list-style: none;
    }
    ul h2{
        text-align: center;

    }
    ul li ul{
        padding:10px 0 ;
        border-bottom: 1px solid #EEEEEE;

    }
    ul li ul li i{
        font-size: 14px;
        font-style: normal;
    }
    .aaaa {
        margin-top: 40px;
        .el-row {
            margin-bottom: 35px;

        }

        .el-col {
            border-radius: 4px;
        }



        .bg-purple {
            background: #f4f8fb;
            border: 1px solid #eee;
        }


        .grid-content {
            border-radius: 4px;
            min-height: 36px;
        }


    }


    .zong{
        padding-bottom: 20px;
        margin-bottom: 20px;
        font-size: 24px;
        font-weight: 600;
        color: #333;

        line-height: 36px;
        box-sizing: border-box;
        position: relative;
    }
    .zong::after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50px;
        height: 2px;
        background-color: #eee;
    }
    .zong1{
        margin: 5px 0;
        font-size: 18px;
        color: #666;
        line-height: 36px;

    }

    /deep/
    .el-input__prefix {
        left: 25px !important;
        top: 28px !important;
        font-size: 20px;
        color: rgb(153, 153, 153);
    }

    .el-input,.el-textarea{
        padding: 20px;

    }
    /deep/
    .el-form-item__label{
        line-height: 100px !important;
        font-size: 18px;
    }
    /deep/
    .el-input__inner{
        height: 60px !important;
    }
    /deep/
    .el-textarea__inner{
        min-height: 250px !important;
    }
    .message{
        margin-top: 200px;
        padding-bottom:50px;
        position: relative;
    }
    .el-form-item__label{
        width: 100px;
    }
    @media screen and (max-width: 768px){

        .aaaa {
            .el-row{
                margin-bottom:0
            }

            .el-col {
                border-radius: 4px;
                margin-bottom: 20px;
            }


        }
        .zong{
            padding-bottom: 0px;
            margin-bottom: 0px;
            font-size: 24px;
            font-weight: 600;
            color: #333;
            line-height: 36px;
            box-sizing: border-box;
            position: relative;
        }
        .zong1{
            margin: 5px 0;
            font-size: 1rem;
            color: #666;
            line-height: 2rem;

        }
        .message{
            margin-top: 0px;
            padding-bottom:50px;
            position: relative;
        }
        /deep/
        .el-form-item__label{
            line-height: unset;
            font-size: 1rem;
        }
        /deep/
        .el-input__inner{
            height: 54px !important;
        }
        /deep/
        .el-textarea__inner{
            min-height: 100px !important;
        }
        /deep/
        .el-form-item__label{
            text-align: left;
            width: 80px !important;
        }
        .el-input,.el-textarea{
            padding: 20px;

        }

        .message{
            .el-col{
                padding: 0 !important;
                height: 90px;


            }
            .el-col:last-child{
                padding: 20px 0px !important;
            }
            .el-button{
                padding:10px 20px !important;
            }
            h3{
                padding: 50px 20px !important;
            }
        }


    }

</style>